/* eslint-disable react/prop-types */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable dot-notation */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-unused-state */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable quote-props */
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import React, { Component } from 'react';

import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import ReactTooltip from 'react-tooltip';

import classes from './ConfigurationScreenContent.css';
import Aux from '../../../hoc/Aux';
import lang from '../../../lang.json';

class ConfigurationScreenContentDefault extends Component {
  render() {
    return (
      <Aux>
        <div className="container-fluid">
          <div className="row">
            <div className="col" />
            <div className={`col-8 ${classes.TitleCard}`}> 
              <div className="row">
                <div className="col-8">
                  <br />
                  <h3> 
                  {lang[this.props.language].def_card_title_1of2}
                  <br />
                  {lang[this.props.language].def_card_title_2of2}
                  </h3>
                  <br />
                  <br />
                  <p className={classes.DescriptionCard}>
                  {lang[this.props.language].def_card_description}
                  </p>
                </div>
                <div className="col-4 align-self-center">
                  <img src={require('../../../assets/img/working.png')} alt="img-psw" className={classes.ImgHome} />
                </div>
              </div>
            </div>
            <div className="col" />
          </div>
          <br />
          <br />
        </div>  
        <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
        <ReactTooltip />
      </Aux>
    );
  }
} 

export default ConfigurationScreenContentDefault;
